import { sourceURL } from '../utils/baseURL'

/**
 * @param {*} time MM-mm-dd HH:mm:ss
 * @returns 毫秒
 */
export function timeToSc (time) {
  if (!time) return ''
  const times = time.replace(/-/g, '/')
  return (Date.parse(times)) / 3600 / 1000
}

const CryptoJS = require('crypto-js')
const key = CryptoJS.enc.Utf8.parse('0th78b15945238f8')

/**
 *  加密
 */
export const aesEncrypt = result => {
  if (result === '') return ''
  const srcs = CryptoJS.enc.Utf8.parse(result)
  return CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

/**
 *  解密
 */
export const aesDecrypt = result => {
  if (result === '') return ''
  const resultStr = CryptoJS.enc.Base64.parse(result)
  const encryptedBase64Str = CryptoJS.enc.Base64.stringify(resultStr)
  const decrypt = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
    mode: CryptoJS.mode.ECB, // ECB CBC
    padding: CryptoJS.pad.Pkcs7 // Pkcs7
  })
  // return decrypt.toString(CryptoJS.enc.Utf8)
  const str = CryptoJS.enc.Utf8.stringify(decrypt).toString()
  return str
}

/**
 * aes解密数组对象
 * @param {Array} list 原数据对象
 * @param {Array} fieldsArr 需要解密的字段名
 * @returns 解密结果
 */
export const aesDecryptList = (list, fieldsArr) => {
  if (!Array.isArray(list) || !list.length) return []
  if (!Array.isArray(fieldsArr) || !fieldsArr.length) return list
  list.forEach(item => {
    Object.keys(item).forEach(field => {
      item[field] = fieldsArr.includes(field) ? aesDecrypt(item[field]) : item[field]
    })
  })
  return list
}

//获取当前时间
/**
 * @returns { String } 年-月-日
 */
export function getFormatDate() {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var date = now.getDate()
  month = month + 1
  month < 10 ? month = '0' + month : month
  date < 10 ? date = '0' + date : date
  var time = year + "-" + month + "-" + date
  return time
}

/* login cover */
export const imgPath = img => {
  return img ? `${sourceURL}/PictureData/${img}` : ''
}

export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

import Cookies from 'js-cookie'

export function setCookie(key, value, expires = 30) {
  // return Cookies.set(key, value)
  // const inFifteenMinutes = new Date(new Date().getTime() + 5 * 1000)
  return Cookies.set(key, value, { expires })
}
export function getCookie(key) {
  return Cookies.get(key)
}
export function removeCookie(key) {
  return Cookies.remove(key)
}

/**
 * date formatting
 * {{ Date() | formatDate }} -> 2020-09-28 15:54:52
 * {{ '2020/10/01 12:30:45' | formatDate('yyyy-MM-dd hh:mm:ss w') }} -> 2020-10-01 12:30:45 星期四
 * @param {Date} value 可以被 new Date(value) 解析的时间格式，如 Date()、2020/10/01、2020-10-01 12:00 等
 * @param {String} fmt 格式化模版
 */
export const formatDate = (value, fmt = 'yyyy-MM-dd hh:mm') => {
  if (!value) {
    return ''
  } else {
    const date = new Date(value)
    const o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'w+': date.getDay(), // week
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      S: date.getMilliseconds() // millisecond
    }

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (var k in o) {
      if (k === 'w+') {
        if (o[k] === 0) {
          fmt = fmt.replace('w', 'Sunday')
        } else if (o[k] === 1) {
          fmt = fmt.replace('w', 'Monday')
        } else if (o[k] === 2) {
          fmt = fmt.replace('w', 'Tuesday')
        } else if (o[k] === 3) {
          fmt = fmt.replace('w', 'Wednesday')
        } else if (o[k] === 4) {
          fmt = fmt.replace('w', 'Thursday')
        } else if (o[k] === 5) {
          fmt = fmt.replace('w', 'Friday')
        } else if (o[k] === 6) {
          fmt = fmt.replace('w', 'Saturday')
        }
      } else if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }

    return fmt
  }
}